import { useRef } from 'react';

import { AdvancedImage, responsive, placeholder } from '@cloudinary/react';
import { scale } from '@cloudinary/url-gen/actions/resize';
import { byRadius } from '@cloudinary/url-gen/actions/roundCorners';
import { format } from '@cloudinary/url-gen/actions/delivery';
import { type AlpacaImage } from '../models/AlpacaImage';
import { myCld } from '../utils/constants';
import { auto } from '@cloudinary/url-gen/qualifiers/format';
import { FaTimes, FaTrashAlt } from 'react-icons/fa';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import AlpacaApi from '../apis/alpaca_api';
import { alpacaKeys } from '../queries/AlpacaQueries';

export default function AlpacaImageComponent({
  image,
}: {
  image: AlpacaImage;
}) {
  const queryClient = useQueryClient();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const mutation = useMutation({
    mutationFn: ({
      alpacaId,
      imageName,
    }: {
      alpacaId: number;
      imageName: string;
    }) => AlpacaApi.deleteAlpacaImage({ alpacaId, imageName }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: alpacaKeys.detail(image.alpacaId),
      });
    },
  });
  const imgSm = myCld
    .image(image.imageName)
    .resize(scale().height(250))
    .roundCorners(byRadius(20))

    .delivery(format(auto()))
    .quality('auto');
  const imgLg = myCld
    .image(image.imageName)

    .delivery(format(auto()))
    .quality('auto');

  const deleteImage = () => {
    const res = confirm('Are you sure you want to delete this image?');
    if (!res) return;
    mutation.mutate({
      alpacaId: image.alpacaId,
      imageName: image.imageName,
    });
  };

  return (
    <div className='flex min-h-[200px] w-full flex-col items-center'>
      <AdvancedImage
        className='max-h-[250px]'
        cldImg={imgSm}
        plugins={[responsive(), placeholder()]}
        onClick={() => dialogRef?.current?.showModal()}
      />

      <button
        type='button'
        className='pt-2 hover:text-rose-600 dark:hover:text-rose-400'
        title='Delete Image!'
        onClick={() => deleteImage()}
      >
        <FaTrashAlt />
      </button>
      <dialog ref={dialogRef} className='bg-white dark:bg-gray-800 m-auto'>
        <div className='flex justify-end'>
          <button
            className='my-2 rounded-md border border-slate-950 bg-transparent
           p-2 text-xs font-bold uppercase text-gray-600 hover:border-gray-400
            hover:text-gray-400 dark:border-gray-500 dark:text-gray-500 dark:hover:border-gray-300 dark:hover:text-gray-400'
            onClick={() => dialogRef?.current?.close()}
          >
            <FaTimes />
          </button>
        </div>
        <div className='flex justify-center'>
          <AdvancedImage
            className='h-full'
            cldImg={imgLg}
            plugins={[responsive(), placeholder()]}
            onClick={() => console.log(true)}
          />
        </div>
      </dialog>
    </div>
  );
}
